var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","fill":"none","viewBox":"0 0 14 14","width":"14","height":"14"}},[_c('path',{attrs:{"stroke":"#121212","stroke-linecap":"round","stroke-width":"1.2","d":"M11.667 3.5L5.25 9.917 2.333 7"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }